import InStockOptions from './InStockOptions';

export default InStockOptions;
